<template>
  <div id="main">
    <TheHeader />
    <ContactCard :id="id" />
    <TheFooter />
  </div>
</template>

<script>
import TheHeader from "@/components/TheHeader.vue";
import TheFooter from "@/components/TheFooter.vue";
import ContactCard from "@/components/ContactCard.vue";

export default {
  name: "Profile",
  props: ["id"],
  components: {
    TheHeader,
    TheFooter,
    ContactCard
  }
};
</script>

<style scoped>
#main {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

#contents {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
